import { render } from "./DashBoard.vue?vue&type=template&id=c3b6788e&scoped=true"
import script from "./DashBoard.vue?vue&type=script&lang=js"
export * from "./DashBoard.vue?vue&type=script&lang=js"

import "./DashBoard.vue?vue&type=style&index=0&id=c3b6788e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3b6788e"]])

export default __exports__